<template>
  <p>callback</p>
</template>

<script>
  import Auth from '@/module/Auth'
  import Config from '@/conf/Config'
  import { sessionApi } from '@/module/Api'

  export default {
    created() {
      this.$logger.info('Logged out', { id: this.session.username })
      
      const session = Auth.getCurrentUser();
      // not async car share api logout.
      sessionApi
        .logout(session.username)
        .then(() => {
          // do nothing
        })
        .catch(() => {
          // do nothing
        })
      Auth.signout()
      this.$router.push(Config.URL.LOGIN_PATH)
    },
  }
</script>
